import { styled } from '@mui/material/styles';
import { Button, Box } from '@mui/material';

export const NavigationFooterContainer = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

// Color/fondo/hover vienen de la variante global `variant="tonal"` del tema (ver
// src/styles/theme/index.ts) — el mismo botón "Cancelar"/"Anterior" que usa Intercambio y
// cualquier otro botón secundario del sistema. Acá solo el tamaño propio de este footer.
export const PreviousButton = styled(Button)(() => ({
  padding: '9px 18px',
  borderRadius: '10px',
  fontSize: '0.875rem',
}));

export const NextButton = styled(Button)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  background: disabled
    ? theme.palette.action.disabledBackground
    : 'linear-gradient(135deg, #06b6d4 0%, #10b981 100%)',
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  fontSize: '0.875rem',
  fontWeight: 500,
  minWidth: '100px',
  border: 'none',
  '&:hover': {
    background: disabled
      ? theme.palette.action.disabledBackground
      : 'linear-gradient(135deg, #0891b2 0%, #059669 100%)',
    border: 'none',
  },
  '&:focus': {
    outline: 'none',
  },
  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
    background: theme.palette.action.disabledBackground,
    border: 'none',
  },
}));

export const EmptySpacer = styled(Box)(() => ({
  // Empty div to maintain layout with flex justify-between
}));

// Mismo motivo que PreviousButton: color/fondo/hover vienen de `variant="tonal"` del tema.
export const SaveDraftButton = styled(Button)(({ theme }) => ({
  padding: '9px 18px',
  borderRadius: '10px',
  fontSize: '0.875rem',
  minWidth: '120px',
  marginRight: theme.spacing(1),
}));

export const ButtonsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));
